export const generateNestedRoute = (...paths: string[]): string => `/${  paths.join('/')}`;
